import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Banner from "./Banner";
import Footer from "./Footer";
import { observer } from 'mobx-react';

import "./Layout.css";

class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="layout">
                <div className="content">
                    <NavMenu store={this.props.store} />
                    <Banner store={this.props.store} />
                    <Container style={{ marginTop: "1em" }} fluid={this.props.store.isFlexLayout}>
                        {this.props.children}
                    </Container>
                </div>
                <Footer></Footer>
          </div>
        );
    }
}

Layout = observer(Layout);

export {Layout}